export { default } from './confirm-in-place';
